export default "__VITE_ASSET__CADFSWPd__"